import _ from "lodash"
import { UUM_URL } from "../../utils/Config"
import { ADD, CC_PRODUCT_ID } from "../../utils/Constants"
import { updateObjectById } from "../../utils/SchemaParseUtils"
import { getSessionItem } from "../../utils/storageUtils"
import { setProgKeysFuncSchema, setProgKeysProfTableList, setProgKeysSchema, setPKParentActionMode, setProgKeysCurrData } from "../reducers/ProgKeysReducer"
import { getSchemaDataResponse, getTableList, updateModelItem } from "./CommonActions"
import confirmModal from "../../components/common/confirmModal"
import { getTranslated } from "../../utils/CommonUtils"
import { setUmcNotification } from "../reducers/CommonReducer"

/*****KEYS-PROFILES******/

/* Get Keys-Profiles Table data */
export const getProgKeysProfList = () => {
    const request = {
        url: `/data/list/keysprofile/${getSessionItem(CC_PRODUCT_ID)}`,
        action: setProgKeysProfTableList
    }
    return (dispatch, getState) => {
        dispatch(getTableList(request))
    }
}

/**** PROG-KEYS popup ****/

/* Get Programmable keys schema */
export const getProgKeysSchema = (callback) => {

    return (dispatch, getState) => {
        const request = { url: `${UUM_URL}/schema/detail/progkeys`, action: setProgKeysSchema, callback }
        dispatch(getSchemaDataResponse(request))
    }
}

/* Get Programmable keys data */
export const getProgKeysData = (dn, type, callback = null) => {

    return (dispatch, getState) => {
        const request = { url: `${UUM_URL}/data/progkeys/${dn}/${type}`, action: null, callback }
        dispatch(getSchemaDataResponse(request))
    }
}

/* Get Programmable keys function schema */
export const getProgKeysFunctionSchema = (deviceType) => {

    return (dispatch, getState) => {
        const request = { url: `${UUM_URL}/schema/detail/${deviceType === "NOE" ? "Noekeyfunctions" : "Sipkeyfunctions"}`, action: setProgKeysFuncSchema }
        dispatch(getSchemaDataResponse(request))
    }
}

/* Update Prog keys action [ CREATE | UPDATE | DELETE ] */
export const updateProgKeysData = (id, data, callback) => {

    return (dispatch, getState) => {
        dispatch(updateModelItem(`${UUM_URL}/data/progkeys/${id}`, (status, response) => {
            callback(status, response)
        }, data))
    }
}


/* Update error status to progkeys data */
export const updateErrorData = (error, progKeysData) => {

    return async (dispatch, getState) => {
        let updatedData = _.cloneDeep(progKeysData)

        for (const errorItem of error) { // Use for loop to make to sync

            updatedData = await updateObjectById(updatedData, "key" + errorItem.key, (data) => {
                let tempData = _.cloneDeep(data)
                if (tempData) {
                    tempData.error = errorItem.errorMessage || true
                }

                return tempData
            })
        }
        dispatch(setProgKeysCurrData(updatedData))
    }
}

/* Reset error on change */
export const removeError = (cell, progKeysData) => {

    return async (dispatch, getState) => {
        const updatedData = await updateObjectById(progKeysData, cell.id, (data) => {
            let tempData = _.cloneDeep(data)
            if (tempData) {
                delete tempData.error
            }

            return tempData
        })
        dispatch(setProgKeysCurrData(updatedData))
    }
}

export const updateProgKeys = (dn, progKeysData, dict, setLoading, callback) => {

    return (dispatch, getState) => {

        dispatch(updateProgKeysData(dn, progKeysData, (status, response) => {
            setLoading(false)
            if (status && response?.response?.length) {
                const errorItems = response.response.filter(item => (item.status === "FAILURE" && item.key))
                if (errorItems?.length) {
                    dispatch(updateErrorData(errorItems, progKeysData))
                    confirmModal({
                        title: "LABEL_FAILED",
                        content: (errorItems.length === 1 && errorItems[0].key === "addonmodule") ? <>{errorItems[0].errorMessage}</> :
                            <table border="1" cellpadding="8" cellspacing="0" className="pk-err-tbl">
                                <tr><th>{getTranslated(dict, "LABEL_KEY")}</th><th>{getTranslated(dict, "LABEL_ERROR")}</th></tr>
                                {errorItems.map(item => {
                                    return <tr><td>{item.key}</td><td>{item.errorMessage}</td></tr>
                                })}
                            </table>,
                        type: "error",
                        okText: "LABEL_OK"
                    })
                } else {
                    dispatch(setUmcNotification({ // Notify the chages saved successfully in OXE - CRUMC-672
                        type: "success",
                        message: getTranslated(dict, "LABEL_SAVED"),
                        description: ""
                    }))
                    dispatch(setPKParentActionMode(ADD))
                    callback && callback(response.response[0])
                }
            } else {
                confirmModal({
                    title: "LABEL_FAILED",
                    content: "",
                    type: "error",
                    okText: "LABEL_OK",
                    // onOk: handleClose()
                })
            }
        }))
    }
}